// Иконки вкладок по серверному имени (config.navigation.tab_bar[].icon). Аналоги SF Symbols из iOS:
// matches=sportscourt, leagues=trophy, favorites=star, news=newspaper, home=house, game=target (мишень), highlights=play.rectangle. Незнакомое имя → нейтральный кружок.
// fantasy (§288, вход в игровой мир) — не контур, а арт мира: калитка-монстр в золотом круге (FantasyIcon).
// quiz (HQ-2329, кнопка квиза дня в шапке) — маска 24 из набора иконок шапки (как лупа и меню), а не контур вкладки.
import questionIcon from '../assets/icons/question.svg';
import wicketArt from '../assets/world/foe/wicket.webp';
import { MaskIcon } from './MenuCell';
const PATHS: Record<string, string> = {
  home: 'M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z',
  matches: 'M3 5h18v14H3zM12 5v14M3 9h3v6H3M21 9h-3v6h3M12 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3',
  leagues: 'M7 4h10v5a5 5 0 0 1-10 0zM7 6H4v1a3 3 0 0 0 3 3M17 6h3v1a3 3 0 0 1-3 3M12 14v4M8 21h8M9 18h6',
  favorites: 'M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z',
  news: 'M4 5h13v14H6a2 2 0 0 1-2-2zM17 9h3v8a2 2 0 0 1-2 2M7 8h7M7 11h7M7 14h4',
  highlights: 'M4 6h16v12H4zM10 9.5v5l4.5-2.5z',
  game: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10M12 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2',
};

/** Иконки-маски кнопок шапки (по серверному icon): цвет — currentColor, размер 24. */
const MASK_ICONS: Record<string, string> = { quiz: questionIcon };

/** Иконки-картинки (не контур): большая вкладка входа в мир. */
export const ART_TAB_ICONS = new Set(['fantasy']);

export function TabIcon({ name, filled }: { name: string; filled: boolean }) {
  if (name === 'fantasy') return <span className="tabArt" aria-hidden="true"><img src={wicketArt} alt="" draggable={false} /></span>;
  const mask = MASK_ICONS[name];
  if (mask) return <MaskIcon src={mask} size={24} />;
  const d = PATHS[name];
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"
      fill={filled ? 'currentColor' : 'none'} fillOpacity={filled ? 0.18 : 0}
      stroke="currentColor" strokeWidth={filled ? 2 : 1.6} strokeLinejoin="round" strokeLinecap="round">
      {d ? <path d={d} /> : <circle cx="12" cy="12" r="7" />}
    </svg>
  );
}
